export enum ContentAreaEnum {
    Courseware = 0,
    Blog = 1,
    Article = 2,
    DigitalBadge = 3
}